import Phaser from 'phaser'
import {gSettings} from '../settings/gamesettings';



// put globals here
var debugText;
var titleText; 

var DEBUG = 1;


export default class TitleScreen extends Phaser.Scene
{

    spaceKey = 0;
	
    init() {
        console.log("TitleScreen init");
       this.spaceKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
	
	}
	preload()
	{
	}

	create()
	{

		titleText = this.add.text(0, 0, "Title Screen - press space to go to game scene");
		debugText = this.add.text(0, 20, "debug");



	}

	update(time, delta) {
	
		if (DEBUG) {
			debugText.setText('Time: ' + time  + '\nDelta: ' + delta.toFixed(2));
		}


	


        

        //  Phase 1: Key event.
        //  Emits only when the SPACE BAR is pressed down, and dispatches from the local Key object.
        //  You can call stopPropagation at this level, which will stop it reaching both listeners below.
		// get key locally
/*
        this.spaceKey.on('down', (key, event) =>
        {

			is.scene.start('Game');

        });
*/
		// check through all keys
		this.input.keyboard.on('keydown', event =>
        {

            if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.SPACE)
            {
				this.scene.start('gameScene');
            }

        });

	



        //  Emits only when the SPACE BAR is pressed down, and dispatches from the local Key object.
        //  You can call stopPropagation at this level, which will stop it reaching both listeners below.
        // get key locally


        this.spaceKey.on('down', (key, event) =>
        {

            // event.stopPropagation();
            console.log(" hello 1");
          //  bubble3.setVisible(true);

        });
 
        //  Phase 2: Global keydown + keycode handler.
        //  Emits only on the SPACE BAR keycode event, but dispatches globally.
        //  You can call stopPropagation at this level, which will stop it reaching the listener below.

        this.input.keyboard.on('keydown-SPACE', event =>
        {

         //   event.stopPropagation();
            console.log(" hello 2");
         //   bubble2.setVisible(true);

        });

        //  Phase 3: Global keydown handler.
        //  Fires on ANY key press, so we need to check the keyCode internally.

        this.input.keyboard.on('keydown', event =>
        {

            if (event.keyCode === Phaser.Input.Keyboard.KeyCodes.SPACE)
            {
                console.log(" hello 3");
            }

        });

    }
}